module.exports = __webpack_public_path__ + "static/media/blog-ads-vs-reco-banner.8ebff29a.jpg";